var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgRing3(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 190,
    height: 197.908,
    viewBox: "0 0 190 197.908",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Vector 14",
    opacity: 0.05,
    d: "M46.0674 14.155C76.1485 -4.05198 113.852 -4.05198 143.933 14.155C172.219 31.2758 189.5 61.9356 189.5 94.9997V102.908C189.5 135.972 172.219 166.632 143.933 183.753C113.852 201.96 76.1485 201.96 46.0674 183.753C17.781 166.632 0.500088 135.972 0.5 102.908V94.9997C0.50009 61.9356 17.781 31.2758 46.0674 14.155Z",
    stroke: "#03A388"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgRing3);
export default __webpack_public_path__ + "static/media/ring3.0e85d0149294d0ee4554da54715cf485.svg";
export { ForwardRef as ReactComponent };